import {
  HeadContent,
  Outlet,
  Scripts,
  createRootRoute,
} from '@tanstack/react-router'
import { Toaster } from 'sonner'

import { ImpersonationBootstrap } from '@/features/admin/impersonation/components/impersonation-bootstrap'
import { AppProviders } from '@/integrations/providers'
import { TanStackDevtools } from '@/integrations/tanstack-devtools'
import appCss from '@/styles/globals.css?url'
// Initialize i18n before any components use it
import '../../i18n'

const SITE_NAME = 'Groute'
const SITE_TITLE = 'Groute — Fleet Management'
const SITE_DESCRIPTION =
  'Groute Fleet Management — vehicle tracking, tachograph compliance, driver hours and route planning for modern transport companies.'
const SITE_URL = 'https://app.mygroute.com'
const OG_IMAGE = `${SITE_URL}/groute-news-logo.png`

export const Route = createRootRoute({
  head: () => ({
    meta: [
      { charSet: 'utf-8' },
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1',
      },
      { title: SITE_TITLE },
      { name: 'description', content: SITE_DESCRIPTION },
      { name: 'application-name', content: SITE_NAME },
      { name: 'apple-mobile-web-app-title', content: SITE_NAME },
      { name: 'apple-mobile-web-app-capable', content: 'yes' },
      {
        name: 'apple-mobile-web-app-status-bar-style',
        content: 'default',
      },
      {
        name: 'theme-color',
        content: '#ffffff',
        media: '(prefers-color-scheme: light)',
      },
      {
        name: 'theme-color',
        content: '#0a0a0a',
        media: '(prefers-color-scheme: dark)',
      },
      { property: 'og:type', content: 'website' },
      { property: 'og:site_name', content: SITE_NAME },
      { property: 'og:title', content: SITE_TITLE },
      { property: 'og:description', content: SITE_DESCRIPTION },
      { property: 'og:url', content: SITE_URL },
      { property: 'og:image', content: OG_IMAGE },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: SITE_TITLE },
      { name: 'twitter:description', content: SITE_DESCRIPTION },
      { name: 'twitter:image', content: OG_IMAGE },
    ],
    links: [
      {
        rel: 'stylesheet',
        href: appCss,
      },
      {
        rel: 'icon',
        type: 'image/svg+xml',
        href: '/favicon/favicon.svg',
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '96x96',
        href: '/favicon/favicon-96x96.png',
      },
      { rel: 'shortcut icon', href: '/favicon/favicon.ico' },
      {
        rel: 'apple-touch-icon',
        sizes: '180x180',
        href: '/favicon/apple-touch-icon.png',
      },
      { rel: 'manifest', href: '/favicon/site.webmanifest' },
    ],
  }),
  component: RootLayout,
})

function RootLayout() {
  return (
    <html lang="rs" suppressHydrationWarning>
      <head>
        <HeadContent />
      </head>
      <body>
        <AppProviders>
          <ImpersonationBootstrap />
          <Outlet />
          <Scripts />
        </AppProviders>

        {/* <TanStackDevtools /> */}
        <Toaster
          position="top-center"
          mobileOffset={{ top: 16, left: 16, right: 16 }}
        />
      </body>
    </html>
  )
}

export default RootLayout
